import { render, staticRenderFns } from "./partHeader.vue?vue&type=template&id=71f87208&scoped=true"
import script from "./partHeader.vue?vue&type=script&lang=js"
export * from "./partHeader.vue?vue&type=script&lang=js"
import style0 from "./partHeader.vue?vue&type=style&index=0&id=71f87208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f87208",
  null
  
)

export default component.exports